/*
 * @Description:
 * @Version: 2.0
 * @Autor: sen.yang
 * @Date: 2021-12-07 10:43:43
 * @LastEditors: sen.yang
 * @LastEditTime: 2022-01-11 16:32:54
 */

import request from "../../utils/request";
import server from "./config";
export default {
    /**
     * 获取咨询订单列表
     */
    getConsultOrderList: (data, noToast = false) => {
        return request({
            url: `${server.MS_PATIENT_CONSUMMER}/patient/consult/1/getPageForPatientOrder`,
            method: "post",
            data,
            noToast
        });
    },
    /**
     * 获取咨询订单详情
     */
    getConsultOrderDetail: (data, noToast = false) => {
        return request({
            url: `${server.MS_PATIENT_CONSUMMER}/patient/consult/1/getDetailForPatient`,
            method: "post",
            data,
            noToast
        });
    },
    /**
     * 取消订单
     */
    cancelConsultRecord: (data, noToast = false) => {
        return request({
            url: `${server.MS_PATIENT_CONSUMMER}/patient/consult/1/cancelConsultRecord`,
            method: "post",
            data,
            noToast
        });
    },
    /**
     * 根据物流包裹id查询无路详情
     */
    getExpressByPackageId: data => {
        return request({
            url: `${server.MS_PATIENT_CONSUMMER}/service/personalcenter/1/getExpressByPackageId`,
            method: "post",
            data
        });
    },
    /**
     * 查询订单里包裹列表
     */
    getGoodsByServiceOrderId: data => {
        return request({
            url: `${server.MS_PATIENT_CONSUMMER}/service/personalcenter/1/getGoodsByServiceOrderId`,
            method: "post",
            data
        });
    },
    /**
     * 服务包确认收货
     */
    confirmReceiptByServiceOrder: data => {
        return request({
            url: `${server.MS_PATIENT_CONSUMMER}/service/agg/order/1/confirmReceipt`,
            method: "post",
            data
        });
    },
    /**
     * 重新支付-咨询订单
     */
    repayToConsult: data => {
        return request({
            url: `${server.MS_PATIENT_CONSUMMER}/patient/consult/1/repayToConsult`,
            method: "post",
            data
        });
    },
    confirmPaymentByAgg: data => {
        return request({
            url: `${server.MS_PATIENT_CONSUMMER}/service/personalcenter/1/confirmPayment`,
            method: "post",
            data
        });
    },
    //判断是否可以修改地址
    validChange: data => {
        return request({
            url: `${server.MS_PATIENT_CONSUMMER}/service/personalcenter/1/validChange`,
            method: "post",
            data
        });
    },
    changeAddress: data => {
        return request({
            url: `${server.MS_PATIENT_CONSUMMER}/service/personalcenter/1/updateDeliveryAddressForPatient`,
            method: "post",
            data
        });
    },
    // 下单前进行基础校验
    checkOrder: data => {
        return request({
            url: `${server.MS_PATIENT_CONSUMMER}/prescription/1/checkOrder`,
            method: "post",
            data
        });
    },
    // 保存订单-处方推荐单
    createOrderPypharmacy: data => {
        return request({
            url: `${server.MS_PATIENT_CONSUMMER}/prescription/1/createOrder`,
            method: "post",
            data
        });
    },
    // 处方、推荐单 是否需要到店自取
    pickUpState: data => {
        return request({
            url: `${server.MS_PATIENT_CONSUMMER}/prescription/1/pickUpState`,
            method: "post",
            data
        });
    },
    // 处方/非处方/服务包修改配送方式
    updateGoodsOrderTransportType: data => {
        return request({
            url: `${server.MS_PATIENT_CONSUMMER}/prescription/1/updateGoodsOrderTransportType`,
            method: "post",
            data
        });
    },
    //
    // 查询订单支付状态
    getOrderPayStatus: (data, noToast = false) => {
        return request({
            url: `${server.MS_PATIENT_CONSUMMER}/patient/1/getOrderPayStatus`,
            method: "post",
            data,
            noToast
        });
    },
    //查询jd子订单
    getJDListById: (data, noToast = false) => {
        return request({
            url: `${server.MS_PATIENT_CONSUMMER}/service/personalcenter/1/order/third/getList`,
            method: "post",
            data
        });
    }
};



// WEBPACK FOOTER //
// ./src/api/modules/order.js